import { ContentModuleTypes, ContentModuleSubTypes, FolderTypes, EVENTS } from '@DavisDigital/interfaces';

class AddButtonModalController {
	
	public contentModule : any;
	public images : [];
	public lesson : any;
	public lessonId : string;
	public portfolioPageId : string;
	
	public disableFileName = false;
	
	public file;
	public fileName = '';
	public fileMode = false; 
	public isLoading = false;
	
	public buttonText = '';
	public buttonUrl = '';
	
	public position;
	
	public saveEvent:string; 
	public setEvent:string;
	public type:string;
	
	public alignmentOptions = [
		'Left',
		'Center',
		'Right'
	]
	
	public buttonAlignment = this.alignmentOptions[0];
	
	
	// @ngInject
	constructor(
		public $timeout,
		public contentService, 
		public imageService,
		public lessonService,
		public ModalService,
		public observerService,
		public portfolioService
	){}
	
	public $onInit = () => {
		
		if(this.saveEvent == null){
			if(this.type === 'lesson'){
				this.saveEvent = 'saveLesson';
			} else { 
				this.saveEvent = 'savePortfolioPage';
			}
		} 
		
		if(this.setEvent == null){
			if(this.type === 'lesson'){
				this.setEvent  = 'setLesson';
			} else {
				this.setEvent  = 'setPortfolioPage';
			}
		} 
		
		if(this.contentModule != null){
			
			this.fileMode = this.contentModule.contentModuleSubType_systemCode === ContentModuleSubTypes.FILE;
			this.buttonText = this.contentModule.title; 
			this.buttonAlignment = this.contentModule.alignment;
			
			if(this.fileMode){
				this.fileName = this.contentModule.file_fileName;
				this.disableFileName = true; 
			} else {
				this.buttonUrl = this.contentModule.contentUrl; 
			}
			
		} else {
			this.contentModule = this.contentService.newContentModule( ContentModuleTypes.BUTTON, this.position);
			this.setContentModuleSubType(ContentModuleSubTypes.LINK);
		}
		
		this.observerService.attach(this.save, 'addButtonContentModule');
	}
	
	public launchFileUpload = () =>{
		angular.element('input[name="downloadFile"]').click();
	}
	
	public setContentModuleSubType = ( systemCode : ContentModuleSubTypes ) =>{
		this.contentModule.contentModuleSubType_systemCode = systemCode;
	}
	
	public setFile = (files) =>{
		
		if(files.length === 0) return; 
	
		this.file = files[0];	
		this.disableFileName = false;
		
		this.$timeout(()=>{
			this.fileName = this.file.name;	
		});
	}
	
	public save = (args?) =>{

		if(args != null){ 
			
			if(args.lessonID != null){
				this.lessonId = args.lessonID;
			}
			
			if(args.portfolioPageID != null){
				this.portfolioPageId = args.portfolioPageID;	
			}
		}
		
		this.isLoading = true;

		let entityName = this.type;
		
		let notifyId;
		
		if(this.type === 'lesson'){
			notifyId = this.lessonId;
		} else {
			notifyId = this.portfolioPageId;
		}
		
		this.contentModule.title = this.buttonText;
		this.contentModule.alignment = this.buttonAlignment;
		
		//do we need to save the thing first
		if(notifyId == null || notifyId.length === 0){
			
			let folderPromise;
			if(this.type !== 'lesson'){
				folderPromise = this.portfolioService.getMyPortfolioFolders({ showAll: true });
			} else {
				folderPromise = this.lessonService.getMyLessonFolders({ showAll: true });
			}
			
			folderPromise.then((response)=>{
				
				var bindings:any = {
					folders: response.data.records,
					saveEvent: 'addButtonContentModule'
				}
				
				if(this.type !== 'lesson'){
					bindings.type = FolderTypes.Portfolio;
				} else {
					bindings.type = FolderTypes.Lesson;
				}
				
				this.ModalService.showModal({
	    			component: 'saveAsModal',
	    			bodyClass: 'angular-modal-service-active',
	    			bindings: bindings,
	    			preClose: (modal) => {
	    				modal.element.modal('hide');
	    			}
	    		}).then((modal) => {
	    			//it's a bootstrap element, use 'modal' to show it
	    			modal.element.modal('show');
	    			modal.close.then((result) => {});
	    		});
			});
    		return;
		}
		
		
		if(this.contentModule.contentModuleSubType_systemCode === 'cmtButtonFile'){
			
			this.contentModule.fileName = this.fileName;
			
			if(this.file != null){
				
				return this.contentService.uploadFileToContentModule(this.file, this.contentModule, notifyId, entityName).then(
					(response) =>{
						this.isLoading=false;
						
						if(response.data.data.success){
							let notifyEvent = this.lessonId?.length ? 'SET_LESSON' : 'SET_PORTFOLIO_PAGE';
							if(notifyId != null && notifyId.length && args == null){
								this.observerService.notifyById( EVENTS[notifyEvent], notifyId, response.data.data[entityName]);
							} else {
								this.observerService.notify( EVENTS[notifyEvent], response.data.data[entityName]);
							}
							return this.close(); 
						}
						return;
					}	
				);
			}
			
		}  else {
			
			this.contentModule.contentUrl = this.buttonUrl;
			
		}
			
		var eventName = EVENTS.UPDATE_CONTENT;
	
		if( !this.contentModule.contentModuleID || 
			 this.contentModule.contentModuleID.length !== 32
		){
			eventName = EVENTS.ADD_CONTENT;
		}
		
		
	
		if(notifyId != null && notifyId.length && args == null){
			this.observerService.notifyById( eventName, notifyId, this.contentModule);
		} else {
			this.observerService.notify(eventName, this.contentModule);
		}
		
		if(args != null){
			let notifyEvent = this.lessonId?.length ? 'SET_LESSON' : 'SET_PORTFOLIO_PAGE';
			
			args.contentModules.push(this.contentModule);
			
			this.observerService.notify( EVENTS[notifyEvent], args);
		}
		
		this.close();
	}
	
	public close = () =>{
		this.ModalService.closeModals();
	}

}

class AddButtonModal {
	public restrict: string = 'E';
	public templateUrl: string;
	public scope: boolean = true;
	
	public bindToController: any = {
		type:'=',
		contentModule:'=?',
		lesson:'=?',
		lessonId:'=?',
		portfolioPageId:'=?',
		position:'='
	};

	public controller = AddButtonModalController;
	public controllerAs = 'addButtonModal';

	public static Factory() {
		var directive:any = ( davisFrontendBasePath ) => new this( davisFrontendBasePath );
		directive.$inject = ['davisFrontendBasePath'];
		return directive;
	}

	constructor(
		private davisFrontendBasePath
	) {
		this.templateUrl = davisFrontendBasePath + '/davisdigital/directives/add-button-modal.html';
	}
}

export { AddButtonModal };
